import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, MapPin, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden" data-id="element-294">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-295">
        <img src="https://cdn.magicpatterns.com/uploads/4hKbcVapnEVcG7A8fQxJcc/josejunk1.png" alt="Jose's Junk Removal Truck at Sunset" className="w-full h-full object-cover object-center" data-id="element-296" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/30" data-id="element-297"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-16 lg:py-24" data-id="element-298">
        <div className="max-w-3xl" data-id="element-299">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-300">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 backdrop-blur-sm mb-6" data-id="element-301">
              <span className="flex h-2 w-2 rounded-full bg-[#C8102E]" data-id="element-302"></span>
              <span className="text-white text-xs sm:text-sm font-semibold tracking-wider uppercase" data-id="element-303">
                Monterey's #1 Full-Service Team
              </span>
            </div>

            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 drop-shadow-lg" data-id="element-304">
              ONE CALL. <br data-id="element-305" />
              <span className="text-[#C8102E]" data-id="element-306">ONE TEAM.</span> <br data-id="element-307" />
              EVERYTHING GONE.
            </h1>

            <p className="text-lg sm:text-xl text-gray-200 mb-10 max-w-2xl font-medium leading-relaxed" data-id="element-308">
              How Monterey Homeowners, Landlords, and Contractors Are Finally
              Clearing Their Properties — Without Renting a Truck, Hiring
              Sketchy Help, or Wasting a Single Weekend.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-309">
              <a href="tel:8312407401" className="flex items-center justify-center gap-3 bg-[#C8102E] text-white px-8 py-4 rounded font-bold text-lg hover:bg-red-800 transition-all shadow-[0_0_20px_rgba(200,16,46,0.4)] hover:shadow-[0_0_30px_rgba(200,16,46,0.6)] hover:-translate-y-1" data-id="element-310">
                <Phone size={24} data-id="element-311" />
                <span data-id="element-312">Call (831) 240-7401</span>
              </a>
              <a href="sms:8312407401" className="flex items-center justify-center gap-3 bg-white text-[#1A1A1A] px-8 py-4 rounded font-bold text-lg hover:bg-gray-100 transition-all shadow-lg hover:-translate-y-1" data-id="element-313">
                <MessageSquare size={24} data-id="element-314" />
                <span data-id="element-315">Text Us Now</span>
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 text-sm text-gray-300 font-medium" data-id="element-316">
              <div className="flex items-center gap-2" data-id="element-317">
                <MapPin size={18} className="text-[#C8102E]" data-id="element-318" />
                <span data-id="element-319">Serving Monterey + 50 miles</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-320">
                <Clock size={18} className="text-[#C8102E]" data-id="element-321" />
                <span data-id="element-322">Same-day & next-day availability</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}